import React, { Fragment } from 'react';
import { Segment, Table, Checkbox, Button, Icon, Grid, Popup, Form } from 'semantic-ui-react';
import moment from 'moment';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import SearchTableData from '../util/SearchTableData';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

// since we dont need to have a way to display only selected, its sufficient to store the id-s only in selectedData
// props: data: [] selectedData: [] onDataChange (fn)

// names in event objects are stored as string while we need to compare them to integer ids
/* eslint-disable eqeqeq */

// data, selectedData, onDataChange (fn)
export default class DataTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            results: [],
            locked: false,
            diplomaReviewed: false,
            onlyNotPrinted: false,
            activeRole: localStorage.getItem('activeRole'),
        };

        this.onSelectRow = this.onSelectRow.bind(this);
        this.getResults = this.getResults.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
        this.markAsPrinted = this.markAsPrinted.bind(this);
    }

    onSelectRow(id) {
        let row = [];
        row = this.props.data.find(el => el.id == id);
        this.props.onDataChange(row);
    }

    getResults(results) {
        this.setState({ results });
    }

    getDataToRender() {
        let data = this.state.results.length !== 0 ? this.state.results : this.props.data;

        if (this.state.locked) {
            data = data.filter(row => row.locked);
        }
        if (this.state.diplomaReviewed) {
            data = data.filter(row => row.diplomaReviewed);
        }
        if (this.state.onlyNotPrinted) {
            data = data.filter(row => !row.diplomaPrinted);
        }

        return data;
    }

    markAsPrinted() {
        const ids = this.props.selectedData.map(e => e.id);
        if (ids.length === 0) {
            toast('Morate označiti bar jednog studenta.');
            return;
        }
        this.setState({
            markAsPrintLoader: true,
        })
        axios.put('/students/set-diploma-printed', ids)
            .then(res => {
                toast('Uspješno označeno kao odštampano');
                this.props.onMarkAsPrinted(ids);
                this.setState({
                    markAsPrintLoader: false,
                })
            })
            .catch(err => {
                toast('Greška pri označavanju');
                this.setState({
                    markAsPrintLoader: false,
                })
            });
    }

    render() {
        const { selectedData, data, studentService } = this.props;
        const dataTable =
            (<Fragment>
                {/* <Segment> */}
                {/*    <h3>Spisak studenata</h3> */}
                {/* </Segment> */}
                {/* <Segment clearing> */}
                <Form>
                    <div style={{ display: 'flex', gap: '20px' }}>
                        <Checkbox
                            type="checkbox"
                            name="locked"
                            id="locked"
                            onChange={(event, data) => {
                                this.setState({ locked: !this.state.locked });
                            }}
                            checked={this.state.locked}
                            label="Zaključani studenti"
                        />
                        <Checkbox
                            type="checkbox"
                            name="diplomaReviewed"
                            id="diplomaReviewed"
                            onChange={(event, data) => {
                                this.setState({ diplomaReviewed: !this.state.diplomaReviewed });
                            }}
                            checked={this.state.diplomaReviewed}
                            label="Verifikovani studenti"
                        />
                        <Checkbox
                            type="checkbox"
                            name="onlyNotPrinted"
                            id="onlyNotPrinted"
                            onChange={(event, data) => {
                                this.setState({ onlyNotPrinted: !this.state.onlyNotPrinted });
                            }}
                            checked={this.state.onlyNotPrinted}
                            label="Neodštampani studenti"
                        />
                    </div>
                </Form>
                <Table selectable celled verticalAlign={"middle"}>
                    <Table.Header>
                        <Table.HeaderCell colSpan={(this.state.activeRole === 'AIDA' || this.state.activeRole === 'Administrator') ? ((this.state.activeRole === 'AIDA' || this.state.activeRole === 'Administrator') && this.props.admin) ? 14 : 15 : 15}>
                            <SearchTableData profMozilla data={data} getResults={this.getResults} filterItem={['firstName', 'lastName', 'indexNumber', 'documentNumber', 'studyProgramName', 'studyProgramBasicName', 'date', 'department']} />
                        </Table.HeaderCell>

                        <Table.Row>
                            { !this.props.admin && <Table.HeaderCell textAlign={"center"}>
                                <Checkbox
                                    type="checkbox"
                                    name="checkAllButton"
                                    value={selectedData.length === data.length}
                                    onChange={this.props.selectAll}
                                    checked={selectedData.length === data.length}
                                />
                            </Table.HeaderCell>}
                            <Table.HeaderCell verticalAlign="middle" colSpan={3}>
                                Prezime i ime studenta/ice
                                <div style={{
                                    fontSize: '0.85em',
                                    color: '#999'
                                }}>Index</div>
                            </Table.HeaderCell>
                            {/* <Table.HeaderCell verticalAlign="middle" colSpan={1}>Verifikovano</Table.HeaderCell> */}
                            {/* <Table.HeaderCell verticalAlign="middle" colSpan={1}>Odštampano</Table.HeaderCell> */}
                            <Table.HeaderCell verticalAlign="middle" colSpan={1}>Broj diplome</Table.HeaderCell>
                            <Table.HeaderCell verticalAlign="middle" colSpan={3}>Odsjek</Table.HeaderCell>
                            <Table.HeaderCell verticalAlign="middle"colSpan={3}>Studijski program</Table.HeaderCell>
                            <Table.HeaderCell verticalAlign="middle" colSpan={2} width={3}>Datum diplomiranja</Table.HeaderCell>
                            <Table.HeaderCell verticalAlign="middle" colSpan={2}>Br. odluke za prijevremeno štampanje</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>

                    <Table.Body> {this.getDataToRender().map(row => (
                        <Table.Row onClick={() => this.onSelectRow(row.id)} key={row.id} className={selectedData.find(e => e.id === row.id) ? 'table-active' : ''}>
                            { !this.props.admin && <Table.Cell textAlign={"center"}>
                                <Checkbox
                                    name={row.id}
                                    type="checkbox"
                                    checked={this.props.selectedData.findIndex(e => e.id === row.id) > -1}
                                />

                            </Table.Cell>}
                            <Table.Cell verticalAlign="middle" colSpan={3}>
                                {row.lastName} {row.firstName}
                                {(row.diplomaReviewed || row.diplomaPrinted || row.locked) ? (
                                    <span style={{
                                        float: 'right',
                                        display: 'flex',
                                        gap: '6px',
                                        alignItems: 'center'
                                    }}>
                                        {row.locked && (
                                            <Popup content="Zaključano" position="top center"
                                                   trigger={<Icon name="lock" color="blue"/>}/>
                                        )}
                                        {row.diplomaReviewed && (
                                            <Popup content="Verifikovano" position="top center"
                                                   trigger={<Icon name="check circle" color="green"/>}/>
                                        )}
                                        {row.diplomaPrinted && (
                                            <Popup content="Odštampano" position="top center"
                                                   trigger={<Icon name="print" color="teal"/>}/>
                                        )}
                                    </span>
                                ) : null}
                                <div style={{
                                    fontSize: '0.85em',
                                    color: '#999'
                                }}>
                                    {row.indexNumber}
                                </div>
                            </Table.Cell>
                            {/* <Table.Cell verticalAlign="middle" colSpan={1}>{row.diplomaReviewed ? "DA" : 'NE'}</Table.Cell> */}
                            {/* <Table.Cell verticalAlign="middle" colSpan={1}>{row.diplomaPrinted ? "DA" : 'NE'}</Table.Cell> */}
                            <Table.Cell verticalAlign="middle" colSpan={1}>{row.documentNumber}</Table.Cell>
                            <Table.Cell verticalAlign="middle" colSpan={3}>{row.departmentsSPOU.map(e => <div>{e.organizationalUnitName} <br /></div>)}</Table.Cell>
                            <Table.Cell verticalAlign="middle" colSpan={3}><strong>{row.studyProgramBasicName}</strong> | {row.studyProgramName}</Table.Cell>
                            <Table.Cell verticalAlign="middle" colSpan={2} width={3}>{row.dateOfGraduation === null ? null : moment(row.dateOfGraduation).format('D. M. YYYY.')}</Table.Cell>
                            <Table.Cell verticalAlign="middle" colSpan={2}>{row.earlyPrintDecisionNumber || "-"}</Table.Cell>
                        </Table.Row>))}
                    </Table.Body>
                </Table>

                {!this.props.admin && <div style={{ float: 'right' }}>
                    Označeno <b>{selectedData.length}</b> od <b>{data.length}</b>.
                </div>}
                <br /><br />
                {studentService ?
                    <Fragment>
                        <Button
                            floated="right"
                            icon
                            labelPosition="left"
                            color="blue"
                            onClick={() => this.props.printCertificates()}
                        >
                            <Icon className="print" />
                            Štampanje
                        </Button>
                    </Fragment>
                    : <Fragment>
                        <Button
                            floated="left"
                            color="blue"
                            basic="true"
                            onClick={() => this.props.changeWizardStep('prev')}
                        >Nazad </Button>
                        {!this.props.admin && <Fragment>
                            <Button
                                loading={this.props.success === false}
                                disabled={this.props.success === false || this.state.markAsPrintLoader}
                                floated="right"
                                icon
                                labelPosition="left"
                                color="blue"
                                onClick={() => this.props.changeWizardStep('next')}
                            >
                                <Icon className="print" />
                                Štampanje
                            </Button>
                            <Button
                                disabled={this.state.markAsPrintLoader || this.props.success === false}
                                loading={this.state.markAsPrintLoader}
                                basic
                                floated="right"
                                icon
                                labelPosition="left"
                                color="blue"
                                onClick={this.markAsPrinted}
                            >
                                <Icon name="check square" />
                                Označi kao odštampano
                            </Button>
                        </Fragment>}
                    </Fragment>
                }
            </Fragment>);

        return (

            <div>
                {dataTable}
                <ToastContainer hideProgressBar/>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/DegreeDocumentPrint/DataTable.js